
<f-dialog
    v-model      = "value"
    :width       = "500"
    :show-delete = "false"
    :show-header = "false"
    @cancel      = "onCancel"
    @store       = "onSave"
>
    <template v-slot:content>
        <c-servicepartner-edit
            v-if        = "company"
            class       = "mt-2 mb-1"
            :company    = "company"
            :show-store = "false"
            ref         = "editor"
            @stored     = "onStored"
        />
    </template>
</f-dialog>
